import { InputProps } from "../../input";

export const listMenu = [
  {
    item: "Como funciona",
    link: "comofunciona",
  },
  {
    item: "Promoções",
    link: "Promoções",
  },
  {
    item: "Indique+",
    link: "https://www.coobmais.com.br/indiquemais/",
  },
  /*{
    item: "Revista de Hotéis",
    link: "http://marketingcoobmais.com.br/Lista-de-hoteis/",
  }*/,
  {
    item: "Parceiros",
    link: "Parceiros",
  },
  {
    item: "Ajuda",
    link: "ajuda",
  },
];

export const dataInputHotelier: InputProps[] = [
  {
    name: "user",
    label: "Usuário",
    id: "usuario",
    description: "Usuário do portal",
    type: "text",
  },
  {
    name: "password",
    label: "Senha",
    id: "senha",
    description: "Mesma senha do Portal do Usuário",
    type: "password",
  },
];

export const dataInputForgottPass: InputProps[] = [
  {
    name: "email",
    label: "email",
    id: "email",
    description: "Insira seu-email",
    type: "email",
  },
];
